import { render, staticRenderFns } from "./HomeBetContentNew.vue?vue&type=template&id=36768618&scoped=true&"
import script from "./HomeBetContentNew.vue?vue&type=script&lang=js&"
export * from "./HomeBetContentNew.vue?vue&type=script&lang=js&"
import style0 from "./HomeBetContentNew.vue?vue&type=style&index=0&id=36768618&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36768618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36768618')) {
      api.createRecord('36768618', component.options)
    } else {
      api.reload('36768618', component.options)
    }
    module.hot.accept("./HomeBetContentNew.vue?vue&type=template&id=36768618&scoped=true&", function () {
      api.rerender('36768618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeBetContentNew.vue"
export default component.exports